<div class="background--login">
  <section class="eula-container">
    <mat-toolbar class="bg-charcoal-10! text-white!">
      <mat-toolbar-row>
        <img src="../../assets/images/logo.svg" />
        <h2 class="toolbar-title">online</h2>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="content-login">
      <div class="eula-text subtitle-1">
        <div>Welcome, {{ currentUser.firstName }} {{ currentUser.lastName }}.</div>
        <div>
          {{
            !!currentUser.eulaApprovedDateTime
              ? 'We have amended the Licence Agreement governing your use of EstImage Online. Please accept the new Terms before continuing to use EstImage Online.'
              : 'Kindly read the following EstImage End User Licence Agreement. To accept, please click the Accept button to continue.'
          }}
        </div>
      </div>
      <mat-divider />
      <div class="eula subtitle-2" [innerHTML]="eulaContent()"></div>
      <mat-divider />
      <div class="eula-text subtitle-1">
        If you agree to the terms and conditions of the EstImage End User Licence Agreement, click Accept, otherwise,
        click Decline.
      </div>
      <mat-divider />
      <div class="buttons-container">
        <button matButton="elevated" class="charcoal-button w-[200px]!" (click)="decline()">DECLINE</button>
        <button matButton="elevated" class="red-button w-[200px]!" type="submit" (click)="agree()">ACCEPT</button>
      </div>
    </div>
  </section>
</div>
